export default __webpack_public_path__ + "static/media/258.1085d916.png";